// extracted by mini-css-extract-plugin
module.exports = {"RV-I":"EU_RV-I__ktppY"};